import { useState, useEffect } from "react";
import * as ReactBootStrap from "react-bootstrap";

import FormData from "form-data";

import axios from "axios";

function BankStatement() {
  const [cardData, setCardData] = useState({
    Document_type: "",
    bank_name: "",
    from_date: "",
    to_date: "",
    account_no: "",
    holder_name: "",
    ifsc_code: "",
    document_type: "",
    status: "",
  });
  const [img, setImg] = useState();
  const [loading , setLoading] = useState(true)

  useEffect(() => {
    // console.log("ththth", cardData);
  }, [cardData]);

  const onChange = (e) => {
    var file = e.target.files[0];
    let base64String = "";

    var reader = new FileReader();
    // console.log("next");

    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      // console.log("base64String", base64String);
      setImg("b " + base64String);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setLoading(false);
    setCardData({
      Document_type: "",
      from_date: "",
      to_date: "",
      account_no: "",
      holder_name: "",
      ifsc_code: "",
      document_type: "",
      status: "",
      bank_name: "",
    });
    var data = new FormData();
    data.append("ImageByte", img);
    var config = {
      method: "post",
      url: "https://vgem11vpji.execute-api.ap-south-1.amazonaws.com/default/bankstatementocrservice",
      headers: {
        "x-api-key": "jCSIISHVNG2e3QLKbX0P82l6LyFM4oLj3mAyUH5R",
        authorizationToken: "5zvVZBuuWsUsXkp5",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        // console.log(JSON.stringify(response.data));
        setCardData(response.data);
        setLoading(true)
      })
      .catch(function (error) {
        setLoading(true)
        alert("Something went wrong with server");
        // console.log(error);
      });
  };

  useEffect(() => {}, [cardData]);

  return (
    <div>
      <div>
        <div className="container containerBoreder " id="pan">
          <h2 className="pageTitle">Bank Statement OCR</h2>
          <div className="row" style={{display:"flex"}}>
            <div className="col-4">
              <input type="file" onChange={onChange} />
            </div>
        
            <br/>
            {loading?(<div className="col-4">
              <button className="btn btn-primary" onClick={submit}>
                Submit
              </button>
            </div>) :<ReactBootStrap.Spinner animation="border" />}
          </div>
          <br />
          <table className="table">
            <tbody>
              <tr>
                <th width="25%">Document Type: </th>
                <td> {cardData.document_type}</td>
              </tr>
              <tr>
                <th>Status</th>
                <td> {cardData.status}</td>
              </tr>
              <tr>
                <th>Bank Name:</th>
                <td> {cardData.bank_name}</td>
              </tr>
              <tr>
                <th>Form Date</th>
                <td>{cardData.from_date} </td>
              </tr>
              <tr>
                <th>To Date</th>
                <td>{cardData.to_date}</td>
              </tr>
              <tr>
                <th>Account Number</th>
                <td>{cardData.account_no}</td>
              </tr>
              <tr>
                <th>Holder Name</th>
                <td>{cardData.holder_name}</td>
              </tr>
              <tr>
                <th>IFSC Code</th>
                <td>{cardData.ifsc_code}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default BankStatement;
